// 医保账号查询——微信，主流程
const wxMainRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `query/wx/index${i + 1}`,
  name: `queryWxIndex${i + 1}`,
  component: () => import(`@/views/health/query/wx/index${i + 1}.vue`)
}))

// 医保账号查询——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `query/zfb/index${i + 1}`,
  name: `queryZfbIndex${i + 1}`,
  component: () => import(`@/views/health/query/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/health',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 医保账号查询——微信，开始
    ...wxMainRoutes,

    // 医保账号查询——支付宝，主流程
    ...zfbMainRoutes
  ]
}
